import React from "react";
import { useTranslation } from "react-i18next";
import FooterSection from "../../../components/sections/FooterSection";
import TextPlusImageCard from "../../../components/sections/TextPlusImageCard";
import ParallaxCallSection from "../../../components/sections/ParallaxCallSection";
import DividersInfoSection from "../../../components/sections/DividersInfoSection";

function VisaWorkOverviewPage(props) {

    var translationHook = useTranslation();
    var t = translationHook.t;

    return (
        <>
            <h1 className="mb-4 uk-text-center uk-margin-large-top">
                Employment Opportunities Overview
            </h1>

            <ParallaxCallSection
                URL="https://qazindustry.gov.kz/img/news/2871496.jpg"
                headline="Find Your Place in Industrial Powerhouse"
                callToAction="Apply for a Work Visa with Jai International"
            />
            <div className="uk-container uk-margin-large-top uk-margin-large-bottom">

                <TextPlusImageCard
                    order="left"
                    title="Rapidly Expanding Economy and Industrial Growth"
                    fatText="Kazakhstan has become one of the fastest-developing economies in Eurasia, driven by state programs
                                    supporting modernization, digital transformation, and industrial diversification. The country
                                    attracts major investments in oil refining, logistics, agriculture, and renewable energy — creating
                                    thousands of stable workplaces and opportunities for skilled and semi-skilled professionals alike."
                    thinText="With strong economic partnerships across Europe, China, and the Middle East, Kazakhstan functions
                                    as a major production and trade hub in Central Asia. Continuous infrastructure upgrades,
                                    international logistics corridors, and special economic zones strengthen its role as a
                                    regional center of innovation and industry."
                    cta="Apply for a Work Visa"
                    imageURL="https://www.gov.kz/uploads/2021/4/6/ebeb3e952c70c90613641ddfd566e5ad_original.1894942.png"
                    imageAlt="Kazakhstan industrial development"
                    imageFrameText=" From manufacturing plants to green energy facilities — Kazakhstan’s growth is driven by both innovation and international collaboration."
                />

                <TextPlusImageCard
                    order="right"
                    title="High Demand for Foreign Specialists and Skilled Workers"
                    fatText="Kazakhstan’s growing economy constantly requires foreign professionals to fill positions in engineering, healthcare, construction, and logistics. Companies actively recruit international talent to meet rising project demands and support new industrial initiatives."
                    thinText="Both private and state-led enterprises value foreign specialists for their expertise, reliability, and experience with international standards. Demand is especially high in oil and gas, information technology, and infrastructure development sectors."
                    cta="Apply for a Work Visa"
                    imageURL="https://au.int/sites/default/files/styles/full/public/newsevents/images/37670-gettyimages-160903824.jpg?itok=7RnFHOxo"
                    imageAlt="Kazakhstan workforce demand"
                    imageFrameText="Kazakhstan’s open labour market welcomes professionals seeking long-term career growth and stability."
                />

                <TextPlusImageCard
                    order="left"
                    title="Accessible Work Visa and Legal Employment Programs"
                    fatText="Kazakhstan maintains simplified visa procedures for skilled workers and investors through government-approved programs. Many industries are part of streamlined hiring channels supported by the Ministry of Labour and Foreign Affairs."
                    thinText="Legal employment frameworks ensure transparent contracts, fair taxation, and social protection for foreign employees. Agencies and employers registered with state authorities assist candidates from visa issuance to full legal employment."
                    cta="Learn More About Visa Options"
                    imageURL="https://www.ahiska-gazeta.com/cms/uploads/images/DSCN6314.jpg"
                    imageAlt="Kazakhstan visa system"
                    imageFrameText="Transparent visa and employment processes help newcomers integrate easily into Kazakhstan’s workforce."
                />

                <TextPlusImageCard
                    order="right"
                    title="Competitive Salaries with Low Cost of Living"
                    fatText="Kazakhstan offers a rare balance between rising wages and affordable living standards. Even mid-level professionals can maintain comfortable lifestyles with access to high-quality housing, food, and transport."
                    thinText="Compared to Western economies, essential goods and services in Kazakhstan remain reasonably priced, allowing foreign employees to save or reinvest earnings while enjoying urban comforts and modern amenities."
                    cta="Discover Work Benefits"
                    imageURL="https://welcome.kz/en/assets/images/products/0_gallery/assets/galleries/252/307-green-bazaar-market-almaty-city-5-large-2.jpeg"
                    imageAlt="Affordable life in Kazakhstan"
                    imageFrameText="Low costs and competitive salaries make Kazakhstan financially appealing to expatriates and skilled migrants."
                />

                <TextPlusImageCard
                    order="left"
                    title="Investment in Infrastructure and Modernization"
                    fatText="Massive national investment programs focus on urban renewal, digital infrastructure, and industrial modernization. The government prioritizes roads, logistics hubs, power generation, and communication networks across all regions."
                    thinText="International companies collaborate with Kazakhstan’s public and private sectors to upgrade national infrastructure. This ongoing modernization fuels demand for skilled professionals and fosters stable, long-term employment."
                    cta="Join Development Projects"
                    imageURL="https://www.zakon.kz/pbi/WEBP/2024-07-04/file-5e5c3082-bd70-4a65-bab9-3906a4d95c74/800x450.webp"
                    imageAlt="Kazakhstan modernization projects"
                    imageFrameText="Infrastructure investment transforms cities and industries, strengthening Kazakhstan’s economic foundations."
                />

                <TextPlusImageCard
                    order="right"
                    title="Multicultural Work Environment and English-Friendly Companies"
                    fatText="Kazakhstan’s corporate and industrial environments are internationally oriented, with English commonly used in major business hubs. Foreign employees integrate easily thanks to inclusive policies and multilingual work teams."
                    thinText="Global firms, startups, and NGOs all operate within Kazakhstan’s growing international business landscape, creating diverse and cooperative workplaces that value cultural exchange and open communication."
                    cta="Explore Work Culture"
                    imageURL="https://invest.gov.kz/upload/resize_cache/iblock/25f/1000_2000_140cd750bba9870f18aada2478b24840a/h8ab95eu629uw5pgxxstf0g4ytsdr4hx.jpg"
                    imageAlt="Multicultural workplace in Kazakhstan"
                    imageFrameText="Inclusive and multilingual corporate environments welcome specialists from every background."
                />

                <TextPlusImageCard
                    order="left"
                    title="Growing Opportunities in Construction, IT, and Energy Sectors"
                    fatText="Kazakhstan’s most active industries — construction, digital technology, and energy — drive the majority of new employment. Large-scale housing, infrastructure, and renewable energy projects attract thousands of specialists annually."
                    thinText="Emerging technology parks and green energy initiatives expand the job market for engineers, technicians, and IT professionals, offering career progression and international project exposure."
                    cta="See Available Positions"
                    imageURL="https://profit.kz/Content/Images/news/ImagineCupKZ2018winners.jpg"
                    imageAlt="Kazakhstan IT and construction"
                    imageFrameText="Dynamic growth sectors provide consistent opportunities for advancement and skill development."
                />

                <TextPlusImageCard
                    order="right"
                    title="Support for Entrepreneurship and Business Startups"
                    fatText="Kazakhstan actively supports entrepreneurship through startup incubators, tax incentives, and simplified registration systems. Government initiatives like 'Digital Kazakhstan' encourage innovation and private enterprise."
                    thinText="Foreign entrepreneurs benefit from special economic zones and partnerships with local investors. The regulatory environment continues to evolve toward transparency and accessibility for small and medium businesses."
                    cta="Start a Business"
                    imageURL="https://theeuropetoday.com/wp-content/uploads/2025/07/Astana-Hub.png"
                    imageAlt="Kazakhstan entrepreneurship"
                    imageFrameText="Vibrant business ecosystems and supportive government programs foster entrepreneurship and innovation."
                />

                <TextPlusImageCard
                    order="left"
                    title="Safe, Welcoming, and Culturally Rich Lifestyle"
                    fatText="Kazakhstan’s cities offer a safe and relaxed environment with welcoming communities. The country’s cultural blend of European, Asian, and nomadic influences provides a unique social and culinary experience."
                    thinText="Foreign residents appreciate the high level of personal safety, low crime rates, and strong sense of hospitality. Local traditions coexist with modern urban life, creating a comfortable atmosphere for newcomers."
                    cta="Learn About Life in Kazakhstan"
                    imageURL="https://astana.citypass.kz/wp-content/uploads/8YEw7HO0jWZD5sXQ0ti2OZeeIfz0Re.jpg"
                    imageAlt="Cultural life in Kazakhstan"
                    imageFrameText="Kazakhstan combines modern living standards with deep-rooted traditions and a welcoming spirit."
                />

                <TextPlusImageCard
                    order="right"
                    title="Strategic Location Connecting Europe and Asia"
                    fatText="Kazakhstan’s geography makes it a strategic logistics and trade bridge between European and Asian markets. The country’s infrastructure connects land routes from China to Europe, supporting global supply chains and transport companies."
                    thinText="Its position enables access to multiple regional markets, making Kazakhstan a preferred base for international corporations and investors looking to expand operations across Eurasia."
                    cta="Explore Business Connectivity"
                    imageURL="https://isnblog.ethz.ch/wp-content/uploads/2022/01/CSSAnalyse249-EN-grafik1.jpg"
                    imageAlt="Kazakhstan trade hub"
                    imageFrameText="Kazakhstan’s central Eurasian position enhances trade, logistics, and international cooperation."
                />

                <p>
                    Jai International offers end-to-end visa assistance and employment placement services for individuals seeking work in Kazakhstan. We specialise in supporting wide spectrum of professionals and skilled workers pursuing better opportunities abroad.
                </p>

                <h2 className="mt-4">
                    Our Support Services Include:
                </h2>

                <ul>
                    <li>Work visa application and full documentation handling</li>
                    <li>Guidance for job interviews and employer communication</li>
                    <li>Assistance with air travel and airport reception</li>
                    <li>Support in finding suitable accommodation</li>
                    <li>Ongoing consultation during initial months of employment</li>
                </ul>

                <p className="mt-4">
                    Whether seeking a technical role, service-sector work, or a skilled trade, our team is ready to connect applicants with verified employers across Kazakhstan. We facilitate a legal and safe path to overseas employment with full transparency and professional care.
                </p>

                <DividersInfoSection />
            </div>
            <FooterSection />

        </>
    );
}

export default VisaWorkOverviewPage;
